import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/pages/404/404.png")